/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 1ae6e2d8 (Tue May  5 20:16:57 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  FetchShopifyMultipassIdentifierBody,
  FetchShopifyMultipassIdentifierBodyToJSON,
  FetchShopifyMultipassIdentifierResponse,
  FetchShopifyMultipassIdentifierResponseFromJSON,
  FetchShopifyMultipassUrlResponse,
  FetchShopifyMultipassUrlResponseFromJSON,
} from '../models'
import * as runtime from '../runtime'

export interface FetchShopifyMultipassIdentifierRequest
  extends runtime.BaseRequestParameters {
  body: FetchShopifyMultipassIdentifierBody
}

export interface FetchShopifyMultipassUrlRequest
  extends runtime.BaseRequestParameters {}

export interface SyncShopifyDiscountsRequest
  extends runtime.BaseRequestParameters {
  userKey: number
}

/**
 * ShopifyApi - interface
 *
 * @export
 * @interface ShopifyApiInterface
 */
export interface ShopifyApiInterface {
  /**
   *
   * @summary Fetches the shopify multipass identifer based on the email in Shopify.
   * @param {FetchShopifyMultipassIdentifierBody} fetchShopifyMultipassIdentifierBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopifyApiInterface
   */
  fetchShopifyMultipassIdentifierRaw(
    requestParameters: FetchShopifyMultipassIdentifierRequest
  ): Promise<runtime.ApiResponse<FetchShopifyMultipassIdentifierResponse>>

  /**
   * Fetches the shopify multipass identifer based on the email in Shopify.
   */
  fetchShopifyMultipassIdentifier(
    requestParameters: FetchShopifyMultipassIdentifierRequest
  ): Promise<FetchShopifyMultipassIdentifierResponse>

  /**
   *
   * @summary Confirms/signs login information to connect users from NC3 to Shopify.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopifyApiInterface
   */
  fetchShopifyMultipassUrlRaw(
    requestParameters: FetchShopifyMultipassUrlRequest
  ): Promise<runtime.ApiResponse<FetchShopifyMultipassUrlResponse>>

  /**
   * Confirms/signs login information to connect users from NC3 to Shopify.
   */
  fetchShopifyMultipassUrl(): Promise<FetchShopifyMultipassUrlResponse>

  /**
   *
   * @summary Syncs shopify discounts to Shopify based on criteria in NC3. This endpoint is called by Shopify.
   * @param {number} userKey Unique identifier for the user account.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopifyApiInterface
   */
  syncShopifyDiscountsRaw(
    requestParameters: SyncShopifyDiscountsRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Syncs shopify discounts to Shopify based on criteria in NC3. This endpoint is called by Shopify.
   */
  syncShopifyDiscounts(
    requestParameters: SyncShopifyDiscountsRequest
  ): Promise<void>
}

/**
 *
 */
export class ShopifyApi extends runtime.BaseAPI implements ShopifyApiInterface {
  /**
   * Fetches the shopify multipass identifer based on the email in Shopify.
   */
  async fetchShopifyMultipassIdentifierRaw(
    requestParameters: FetchShopifyMultipassIdentifierRequest
  ): Promise<runtime.ApiResponse<FetchShopifyMultipassIdentifierResponse>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling fetchShopifyMultipassIdentifier.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/shopify/multipass-identifier`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: FetchShopifyMultipassIdentifierBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchShopifyMultipassIdentifierResponseFromJSON(jsonValue)
    )
  }

  /**
   * Fetches the shopify multipass identifer based on the email in Shopify.
   */
  async fetchShopifyMultipassIdentifier(
    requestParameters: FetchShopifyMultipassIdentifierRequest
  ): Promise<FetchShopifyMultipassIdentifierResponse> {
    const response = await this.fetchShopifyMultipassIdentifierRaw(
      requestParameters
    )
    return await response.value()
  }

  /**
   * Confirms/signs login information to connect users from NC3 to Shopify.
   */
  async fetchShopifyMultipassUrlRaw(
    requestParameters: FetchShopifyMultipassUrlRequest
  ): Promise<runtime.ApiResponse<FetchShopifyMultipassUrlResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/shopify/multipass-login`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchShopifyMultipassUrlResponseFromJSON(jsonValue)
    )
  }

  /**
   * Confirms/signs login information to connect users from NC3 to Shopify.
   */
  async fetchShopifyMultipassUrl(
    requestParameters?: FetchShopifyMultipassUrlRequest
  ): Promise<FetchShopifyMultipassUrlResponse> {
    const response = await this.fetchShopifyMultipassUrlRaw(
      requestParameters || {}
    )
    return await response.value()
  }

  /**
   * Syncs shopify discounts to Shopify based on criteria in NC3. This endpoint is called by Shopify.
   */
  async syncShopifyDiscountsRaw(
    requestParameters: SyncShopifyDiscountsRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.userKey === null ||
      requestParameters.userKey === undefined
    ) {
      throw new runtime.RequiredError(
        'userKey',
        'Required parameter requestParameters.userKey was null or undefined when calling syncShopifyDiscounts.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/shopify/discounts/{userKey}`.replace(
        `{${'userKey'}}`,
        encodeURIComponent(String(requestParameters.userKey))
      ),
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Syncs shopify discounts to Shopify based on criteria in NC3. This endpoint is called by Shopify.
   */
  async syncShopifyDiscounts(
    requestParameters: SyncShopifyDiscountsRequest
  ): Promise<void> {
    await this.syncShopifyDiscountsRaw(requestParameters)
  }
}
